import { AutoDataPrefixer } from "../dom-tools/AutoDataPrefixer";
import { CDSelector } from "./CDSelector";

export class CDElement 
{
  static readonly CDRootType = "CD-ROOT";
  static readonly CDPropertyType = "CD-PROPERTY";
  static readonly CDSelectorType = "CD-SELECTOR";
  static readonly CDTextType = "CD-TEXT";
  static readonly CDKeyFramesType = "CD-KEY-FRAMES";
  static readonly CDMediaQueryType = "CD-MEDIA-QUERY";

  private _type:string;
  private _element:Element;

  constructor( type:string ) 
  {
    this._type = type;
    this._element = document.createElement( type );
    ( this._element as any )._cdElement_ = this;
  }

  get type() 
  {
    return this._type;
  }

  get isRoot() 
  {
    return this._type === CDElement.CDRootType;
  }

  get isSelector() 
  {
    return this._type === CDElement.CDSelectorType;
  }

  get isProperty() 
  {
    return this._type === CDElement.CDPropertyType;
  }

  get isKeyFrames()
  {
    return this._type === CDElement.CDKeyFramesType;
  }

  get isText() 
  {
    return this._type === CDElement.CDTextType;
  }

  get element()
  {
    return this._element;
  }

  get parent():CDElement
  {
    return CDElement.asCDElement( this.element.parentNode as Element );
  }

  get children() :CDElement[]
  {
    let childNodes = this.element.childNodes;
    let children:CDElement[] = [];

    for ( let i = 0; i < childNodes.length; i++ ) 
    {
      if ( Node.ELEMENT_NODE === childNodes[i].nodeType ) 
      {
        let cdElement = CDElement.asCDElement( childNodes[i] as Element );

        if ( cdElement ) 
        {
          children.push( cdElement );
        }
      }
    }

    return children;
  }

  $( selector:string ) 
  {
    if ( !selector ) 
    {
      return this.element;
    }

    selector = AutoDataPrefixer.apply( selector );
    return CDElement.asCDElement( this.element.querySelector( selector ));
  }

  $$( selector:string ) 
  {
    selector = AutoDataPrefixer.apply( selector );
    let list = this.element.querySelectorAll( selector );

    let elements = [];
    
    for ( let i = 0; i < list.length; i++ ) 
    {
      elements.push( CDElement.asCDElement( list[i] ));
    }

    return elements;
  }

  get selectorScope():string 
  {
    let parent = this.parent;

    if ( parent ) 
    {
      return parent.selectorScope;
    }

    return null;
  }

  get parentSelector():CDSelector 
  {
    let iterator = this.parent;

    while ( iterator !== null ) 
    {
      if ( iterator.isSelector ) 
      {
        return iterator as CDSelector;
      }

      iterator = iterator.parent;
    }

    return null;
  }

  setAttribute( key:string, value:string ) 
  {
    this.element.setAttribute( key, value );
  }

  getAttribute( key:string ) 
  {
    return this.element.getAttribute( key );
  }

  static asCDElement( element:Element ) 
  {
    if ( ! element ) 
    {
        return null;
    }
    return ( element as any )._cdElement_;
  }

  appendChild( cdElement:CDElement ) 
  {
    this._element.appendChild( cdElement.element );
  }

  remove( cdElement:CDElement ) 
  {
    this._element.removeChild( cdElement.element );
  }

  insertBefore( newElement:CDElement, refChild:CDElement ) 
  {
    this._element.insertBefore( newElement.element, refChild.element );
  }
}